// Mapping of aircraft types to sprite grid positions (row, column)
// Based on beluga_sprites_description.png
const aircraftSpriteMap = {
  // Row 0
  'CRJ7': { row: 14, col: 0 }, // CRJ-700 - use the CRJ-900 silhouette (r0c2 is a "?" placeholder)
  'A320': { row: 0, col: 3 },
  'B752': { row: 0, col: 4 },
  'B772': { row: 0, col: 5 },
  'EUFI': { row: 0, col: 6 },
  'UH1': { row: 0, col: 7 },

  // Row 1
  'ASK2': { row: 1, col: 0 },

  // Row 4
  'A10': { row: 4, col: 0 },
  'A124': { row: 4, col: 1 },
  'A19N': { row: 4, col: 2 },
  'A319': { row: 4, col: 2 },
  'A20N': { row: 4, col: 3 },
  'A21N': { row: 4, col: 4 },
  'A225': { row: 4, col: 5 },
  'A306': { row: 4, col: 6 },
  'A310': { row: 4, col: 7 },

  // Row 5
  'A318': { row: 5, col: 0 },
  'A321': { row: 5, col: 2 },
  'A332': { row: 5, col: 3 },
  'A333': { row: 5, col: 4 },
  'A337': { row: 5, col: 5 },
  'A338': { row: 5, col: 6 },
  'A339': { row: 5, col: 7 },

  // Row 6
  'A342': { row: 6, col: 0 },
  'A343': { row: 6, col: 1 },
  'A345': { row: 6, col: 2 },
  'A346': { row: 6, col: 3 },
  'A359': { row: 6, col: 4 },
  'A35K': { row: 6, col: 5 },
  'A388': { row: 6, col: 6 },
  'A3ST': { row: 6, col: 7 },

  // Row 7
  'A4': { row: 7, col: 0 },
  'A400': { row: 7, col: 1 },
  'HJET': { row: 7, col: 2 },
  'AN26': { row: 7, col: 3 },
  'AS21': { row: 7, col: 4 },
  'AT45': { row: 7, col: 7 },

  // Row 8
  'AT72': { row: 8, col: 0 }, // ATR 72 - use AT75 icon
  'AT75': { row: 8, col: 0 },
  'AT76': { row: 8, col: 0 }, // ATR 72-600 - use AT75 icon
  'AT82': { row: 8, col: 0 }, // ATR 82 - use AT75 icon (same family)
  'ATP': { row: 8, col: 1 },
  'B190': { row: 8, col: 2 },
  'B29': { row: 8, col: 3 },
  'B350': { row: 8, col: 4 },
  'B38M': { row: 8, col: 5 },
  'B39M': { row: 8, col: 6 },
  'B52': { row: 8, col: 7 },

  // Row 9
  'B703': { row: 9, col: 0 },
  'B712': { row: 9, col: 1 },
  'B733': { row: 9, col: 2 },
  'B734': { row: 9, col: 3 },
  'B735': { row: 9, col: 4 },
  'B736': { row: 9, col: 6 }, // Using B738 icon
  'B737': { row: 9, col: 5 },
  'B738': { row: 9, col: 6 },
  'B739': { row: 9, col: 7 },

  // Row 10
  'B742': { row: 10, col: 0 },
  'B744': { row: 10, col: 1 },
  'B748': { row: 10, col: 2 },
  'B74S': { row: 10, col: 3 },
  'B762': { row: 10, col: 7 }, // Using B763 icon
  'B763': { row: 10, col: 7 },

  // Row 11
  'B764': { row: 11, col: 0 },
  'B773': { row: 11, col: 2 },
  'B779': { row: 11, col: 3 },
  'B77L': { row: 11, col: 4 },
  'B77W': { row: 11, col: 5 },
  'B788': { row: 11, col: 6 },
  'B789': { row: 11, col: 7 },

  // Row 12
  'B78X': { row: 12, col: 0 },
  'BCS1': { row: 12, col: 1 },
  'BCS3': { row: 12, col: 2 },
  'BLCF': { row: 12, col: 3 },
  'C130': { row: 12, col: 4 },
  'C30J': { row: 12, col: 4 }, // C-130J Super Hercules - same as C130
  'C17': { row: 12, col: 5 },
  'C172': { row: 12, col: 6 },
  // Cessna high-wing singles - all share the C172 silhouette
  'C150': { row: 12, col: 6 },
  'C152': { row: 12, col: 6 },
  'C162': { row: 12, col: 6 },
  'C72R': { row: 12, col: 6 }, // 172RG Cutlass
  'C175': { row: 12, col: 6 },
  'C177': { row: 12, col: 6 },
  'C77R': { row: 12, col: 6 }, // 177RG Cardinal
  'C180': { row: 12, col: 6 },
  'C182': { row: 12, col: 6 },
  'C82R': { row: 12, col: 6 }, // 182RG
  'C82T': { row: 12, col: 6 }, // T182
  'C185': { row: 12, col: 6 },
  'C205': { row: 12, col: 6 },
  'C206': { row: 12, col: 6 },
  'T206': { row: 12, col: 6 }, // T206 Turbo Stationair
  'C207': { row: 12, col: 6 },
  'C210': { row: 12, col: 6 },
  'T210': { row: 12, col: 6 }, // T210 Turbo Centurion
  'P210': { row: 12, col: 6 }, // P210 Pressurized Centurion
  'CC19': { row: 12, col: 6 }, // Cessna Skycatcher / Corvalis variants
  'SR20': { row: 22, col: 2 }, // Cirrus SR20 - as SR22
  'S22T': { row: 22, col: 2 }, // Cirrus SR22T - as SR22
  'M20P': { row: 20, col: 4 }, // Mooney M20 (piston) - low-wing single, as PA-28
  'M20T': { row: 20, col: 4 }, // Mooney M20 (turbo) - as M20P
  'WT9': { row: 20, col: 4 },  // Aerospool WT-9 Dynamic - low-wing single, as PA-28
  'SD4': { row: 20, col: 4 },  // Tomark SD-4 Viper - low-wing LSA, as WT9/PA-28
  'PIVI': { row: 12, col: 6 }, // Pipistrel Virus / Explorer - high-wing single, as C172
  'PIVE': { row: 12, col: 6 }, // Pipistrel Velis Electro - Virus airframe, as PIVI
  'PIAT': { row: 12, col: 6 }, // Pipistrel Alpha Trainer - Virus airframe, as PIVI
  'PIAE': { row: 12, col: 6 }, // Pipistrel Alpha Electro - Virus airframe, as PIVI
  'P46T': { row: 20, col: 5 }, // Piper Malibu Meridian / M500 / M600 - as PA46
  // Piper PA-28 / PA-32 variants and other low-wing singles - as PA-28
  'P28B': { row: 20, col: 4 }, // PA-28-235 Dakota
  'P28R': { row: 20, col: 4 }, // PA-28R Arrow
  'P28T': { row: 20, col: 4 }, // PA-28RT Turbo Arrow
  'PA32': { row: 20, col: 4 }, // PA-32 Cherokee Six
  'P32R': { row: 20, col: 4 }, // PA-32R Saratoga
  'P32T': { row: 20, col: 4 }, // PA-32RT Turbo Lance
  'BE33': { row: 20, col: 4 }, // Beech Debonair
  'BE35': { row: 20, col: 4 }, // Beech V-tail Bonanza
  'BE36': { row: 20, col: 4 }, // Beech Bonanza A36
  'DA40': { row: 22, col: 2 }, // Diamond DA40 - composite low-wing single, as SR22
  'TBM7': { row: 20, col: 6 }, // Daher TBM 700 - single turboprop, as PC12
  'TBM8': { row: 20, col: 6 }, // Daher TBM 850
  'TBM9': { row: 20, col: 6 }, // Daher TBM 900/910/930/940/960
  'DA42': { row: 14, col: 6 }, // Diamond DA42 Twin Star - sheet has its own cell
  'DA62': { row: 14, col: 6 }, // Diamond DA62 - as DA42
  // Tecnam - high-wing singles as C172, low-wing singles as PA-28, twins as DA42 / Islander
  'TWEN': { row: 12, col: 6 }, // P2010 Twenty-Ten
  'P208': { row: 12, col: 6 }, // P2008
  'ECHO': { row: 12, col: 6 }, // P92 Echo
  'SIRA': { row: 20, col: 4 }, // P2002 Sierra
  'ASTO': { row: 20, col: 4 }, // Astore
  'BRAV': { row: 20, col: 4 }, // P2004 Bravo
  'GOLF': { row: 20, col: 4 }, // P96 Golf
  'P06T': { row: 14, col: 6 }, // P2006T - light twin, as DA42
  'P212': { row: 24, col: 3 }, // P2012 Traveller - high-wing commuter twin, as Islander
  // Straight-wing turboprop / piston trainers - as PC-9
  'TEX2': { row: 20, col: 7 }, // Beechcraft T-6 Texan II (PC-9 derivative)
  'T6': { row: 20, col: 7 },   // North American AT-6 Texan / Harvard
  'PC21': { row: 20, col: 7 }, // Pilatus PC-21
  'TUCA': { row: 20, col: 7 }, // Embraer EMB-312 Tucano

  // Row 13
  'C208': { row: 13, col: 0 },
  'C25B': { row: 13, col: 1 },
  'C295': { row: 13, col: 2 },
  'C5M': { row: 13, col: 3 },
  'C750': { row: 13, col: 4 },
  'C135': { row: 13, col: 5 },
  'CRJ2': { row: 13, col: 6 },
  'CRJX': { row: 13, col: 7 },

  // Row 14
  'CRJ9': { row: 14, col: 0 },
  'D228': { row: 14, col: 2 },
  'D328': { row: 14, col: 3 },
  'D442': { row: 14, col: 4 },
  'DC10': { row: 14, col: 5 },
  'DC3': { row: 14, col: 6 },
  'DC87': { row: 14, col: 7 },

  // Row 15
  'DH8C': { row: 15, col: 0 },
  'DH8D': { row: 15, col: 1 },
  'E135': { row: 13, col: 6 }, // ERJ-135 - use CRJ2 icon (rear-engined regional jet)
  'E145': { row: 13, col: 6 }, // ERJ-145 - use CRJ2 icon (rear-engined regional jet)
  'E170': { row: 15, col: 2 },
  'E175': { row: 15, col: 2 },
  'E75L': { row: 15, col: 2 }, // E175 long-wing (winglets) - the common E175 designator, same silhouette
  'E75S': { row: 15, col: 2 }, // E175 short-wing
  'E190': { row: 15, col: 3 },
  'E195': { row: 15, col: 3 },
  'E290': { row: 15, col: 3 }, // E190-E2 - same silhouette as E190
  'E295': { row: 15, col: 3 },
  'E275': { row: 15, col: 2 }, // E175-E2 - same silhouette as E175
  'E35L': { row: 15, col: 4 },
  'E3CF': { row: 15, col: 5 },
  'E3TF': { row: 15, col: 6 },
  'E8': { row: 15, col: 7 },

  // Row 16
  'EC35': { row: 16, col: 0 },
  'H135': { row: 16, col: 0 }, // Airbus H135 (formerly EC135)
  'EC45': { row: 16, col: 1 },
  'H145': { row: 16, col: 1 }, // Airbus H145 (formerly EC145)
  'BK17': { row: 16, col: 1 }, // MBB BK 117 (similar to EC145)
  'F15': { row: 16, col: 3 },
  'F16': { row: 16, col: 4 },
  'F18H': { row: 16, col: 5 },
  'F18S': { row: 16, col: 6 },
  'F22': { row: 16, col: 7 },

  // Row 17
  'F35': { row: 17, col: 0 },
  'F406': { row: 17, col: 1 },
  'F5': { row: 17, col: 2 },
  'F50': { row: 17, col: 3 },
  'F2TH': { row: 17, col: 4 }, // Falcon 2000 - use FA7X icon
  'F900': { row: 17, col: 4 }, // Falcon 900 - use FA7X icon
  'FA10': { row: 17, col: 4 }, // Falcon 10 - use FA7X icon
  'FA20': { row: 17, col: 4 }, // Falcon 20 - use FA7X icon
  'FA50': { row: 17, col: 4 }, // Falcon 50 - use FA7X icon
  'FA6X': { row: 17, col: 4 }, // Falcon 6X - use FA7X icon
  'FA7X': { row: 17, col: 4 },
  'FA8X': { row: 17, col: 4 }, // Falcon 8X - use FA7X icon
  'GALX': { row: 17, col: 6 }, // Using GL5T icon (Gulfstream)
  'GL5T': { row: 17, col: 6 },
  'GLF6': { row: 17, col: 7 },
  'GLF4': { row: 17, col: 6 }, // Gulfstream G-IV - GL5T silhouette
  'GLF5': { row: 17, col: 6 }, // Gulfstream G-V/G550 - GL5T silhouette
  'GL7T': { row: 17, col: 6 }, // Global 7500 - large-cabin, GL5T silhouette

  // Row 18
  'GYRO': { row: 18, col: 0 },
  'H47': { row: 18, col: 1 },
  'CH47': { row: 18, col: 1 }, // Chinook variant
  'H60': { row: 18, col: 2 },
  'UH60': { row: 18, col: 2 }, // Sikorsky UH-60 Black Hawk
  'S70': { row: 18, col: 2 },  // Sikorsky S-70 (civilian Black Hawk)
  'S70A': { row: 18, col: 2 }, // S-70A variant
  'S70B': { row: 18, col: 2 }, // S-70B variant
  'S70I': { row: 18, col: 2 }, // S-70i variant
  'H60L': { row: 18, col: 2 }, // UH-60L variant
  'H60M': { row: 18, col: 2 }, // UH-60M variant
  'MH60': { row: 18, col: 2 }, // MH-60 variant
  'SH60': { row: 18, col: 2 }, // SH-60 Seahawk
  'HH60': { row: 18, col: 2 }, // HH-60 Pave Hawk
  'H64': { row: 18, col: 3 },
  'AH64': { row: 18, col: 3 }, // Apache variant
  'HAWK': { row: 18, col: 4 },
  'HUNT': { row: 18, col: 5 },
  'IL62': { row: 18, col: 6 },
  'IL76': { row: 18, col: 7 },

  // Row 19
  'J328': { row: 19, col: 0 },
  'K35E': { row: 19, col: 1 },
  'L159': { row: 19, col: 2 },
  'LJ35': { row: 19, col: 3 },
  'LYNX': { row: 19, col: 4 },
  'M326': { row: 19, col: 5 },
  'MD11': { row: 19, col: 6 },
  'MIL24': { row: 19, col: 7 },

  // Row 20
  'MIRA': { row: 20, col: 0 },
  'MRF1': { row: 20, col: 1 },
  'NH90': { row: 20, col: 2 },
  'P3': { row: 20, col: 3 },
  'P28A': { row: 20, col: 4 },
  'PA46': { row: 20, col: 5 },
  'PC12': { row: 20, col: 6 },
  'PC9': { row: 20, col: 7 },

  // Row 21
  'Q4': { row: 21, col: 0 },
  'R135': { row: 21, col: 1 },
  'R44': { row: 21, col: 2 },
  'RFAL': { row: 21, col: 3 },
  'RJ85': { row: 21, col: 4 },
  'SB39': { row: 21, col: 6 },
  'SF25': { row: 21, col: 7 },

  // Row 22
  'SF34': { row: 22, col: 0 },
  'SGUP': { row: 22, col: 1 },
  'SR22': { row: 22, col: 2 },
  'T38': { row: 22, col: 3 },
  'TIGR': { row: 22, col: 4 },
  'AN12': { row: 23, col: 3 },
  'C160': { row: 23, col: 4 },
  'ST75': { row: 23, col: 5 },
  'U2': { row: 22, col: 7 },

  // Row 24
  'P180': { row: 24, col: 0 },
  'SU95': { row: 24, col: 1 },
  'T204': { row: 24, col: 2 },
  'BN2P': { row: 24, col: 3 },
  'DO28': { row: 24, col: 4 },
  'DO27': { row: 24, col: 5 },
  'E300': { row: 24, col: 6 },
  'PC6T': { row: 24, col: 7 },

  // Row 25
  'B722': { row: 25, col: 0 },
  'E737': { row: 25, col: 5 },
  'E390': { row: 25, col: 6 },
  'KC2': { row: 25, col: 7 },

  // Row 26
  'P1': { row: 26, col: 0 },
  'VF35': { row: 26, col: 1 },
  'CL2T': { row: 26, col: 2 },

  // Additional Helicopter Mappings
  // AgustaWestland / Leonardo helicopters
  'A109': { row: 16, col: 0 }, // AW109 - light twin, similar to EC135
  'A119': { row: 16, col: 0 }, // AW119 Koala - light single, use EC135 sprite
  'A139': { row: 20, col: 2 }, // AW139 - medium twin, use NH90 sprite
  'A149': { row: 20, col: 2 }, // AW149 - medium twin, use NH90 sprite
  'A169': { row: 16, col: 1 }, // AW169 - light twin, use EC145 sprite
  'A189': { row: 21, col: 5 }, // AW189 - heavy twin, use S61 sprite
  'AW09': { row: 16, col: 0 }, // AW109 variant
  'AW19': { row: 16, col: 0 }, // AW119 variant
  'AW39': { row: 20, col: 2 }, // AW139 variant
  'AW69': { row: 16, col: 1 }, // AW169 variant
  'AW89': { row: 21, col: 5 }, // AW189 variant
  'W3': { row: 20, col: 2 },   // PZL W-3 Sokol (similar size to AW139)

  // Bell helicopters
  'B06': { row: 21, col: 2 },  // Bell 206 JetRanger - light, use R44 sprite
  'B105': { row: 16, col: 1 }, // MBB Bo 105 - light twin, use EC145 sprite
  'B205': { row: 0, col: 7 },  // Bell 205 - use UH1 sprite
  'B206': { row: 21, col: 2 }, // Bell 206 - light, use R44 sprite
  'B212': { row: 0, col: 7 },  // Bell 212 - use UH1 sprite
  'B214': { row: 0, col: 7 },  // Bell 214 - use UH1 sprite
  'B222': { row: 16, col: 1 }, // Bell 222 - light twin
  'B230': { row: 16, col: 1 }, // Bell 230 - light twin
  'B407': { row: 21, col: 2 }, // Bell 407 - light single, use R44 sprite
  'B412': { row: 0, col: 7 },  // Bell 412 - use UH1 sprite
  'B427': { row: 16, col: 1 }, // Bell 427 - light twin
  'B429': { row: 16, col: 1 }, // Bell 429 - light twin, use EC145 sprite
  'B430': { row: 16, col: 1 }, // Bell 430 - medium twin
  'B505': { row: 21, col: 2 }, // Bell 505 - light single
  'B525': { row: 21, col: 5 }, // Bell 525 Relentless - heavy twin
  'BH06': { row: 21, col: 2 }, // Bell 206 variant
  'BH07': { row: 21, col: 2 }, // Bell 407 variant

  // Eurocopter / Airbus Helicopters
  'AS32': { row: 7, col: 5 },  // AS332 Super Puma
  'AS50': { row: 16, col: 0 }, // AS350 Écureuil/AStar - light single
  'AS55': { row: 16, col: 0 }, // AS355 Twin Squirrel - light twin
  'AS65': { row: 7, col: 5 },  // AS365 Dauphin - medium twin
  'EC20': { row: 23, col: 6 }, // EC120 Colibri
  'EC25': { row: 7, col: 5 },  // EC225 Super Puma
  'EC30': { row: 16, col: 0 }, // EC130 - light single
  'EC55': { row: 7, col: 5 },  // EC155 - medium twin
  'EC75': { row: 7, col: 5 },  // EC175 - medium twin
  'H120': { row: 23, col: 6 }, // Airbus H120 (EC120)
  'H125': { row: 16, col: 0 }, // Airbus H125 (AS350)
  'H130': { row: 16, col: 0 }, // Airbus H130 (EC130)
  'H155': { row: 7, col: 5 },  // Airbus H155 (EC155)
  'H160': { row: 20, col: 2 }, // Airbus H160 - medium twin
  'H175': { row: 7, col: 5 },  // Airbus H175 (EC175)
  'H215': { row: 7, col: 5 },  // Airbus H215 (AS332)
  'H225': { row: 7, col: 5 },  // Airbus H225 (EC225)

  // Robinson helicopters
  'R22': { row: 21, col: 2 },  // Robinson R22 - light single
  'R66': { row: 21, col: 2 },  // Robinson R66 - light single

  // Sikorsky helicopters
  'S61': { row: 21, col: 5 },  // Sikorsky S-61
  'S64': { row: 21, col: 5 },  // Sikorsky S-64 Skycrane
  'S76': { row: 20, col: 2 },  // Sikorsky S-76 - medium twin
  'S92': { row: 21, col: 5 },  // Sikorsky S-92 - heavy twin
  'S76A': { row: 20, col: 2 }, // S-76A variant
  'S76B': { row: 20, col: 2 }, // S-76B variant
  'S76C': { row: 20, col: 2 }, // S-76C variant
  'S76D': { row: 20, col: 2 }, // S-76D variant

  // MD Helicopters
  'MD52': { row: 21, col: 2 }, // MD 520N - light single
  'MD60': { row: 21, col: 2 }, // MD 600N - light single
  'MD90': { row: 16, col: 0 }, // MD Explorer - light twin
  'NOTR': { row: 21, col: 2 }, // MD 500/NOTAR - light single
  'EXPL': { row: 16, col: 0 }, // MD Explorer

  // Mil helicopters (Russian)
  'MI8': { row: 18, col: 2 },  // Mil Mi-8 - medium, use H60 sprite
  'MI17': { row: 18, col: 2 }, // Mil Mi-17 - medium
  'MI24': { row: 19, col: 7 }, // Mil Mi-24 Hind
  'MI26': { row: 18, col: 1 }, // Mil Mi-26 - heavy, use H47 sprite
  'MI28': { row: 18, col: 3 }, // Mil Mi-28 - attack, use H64 sprite
  'MI35': { row: 19, col: 7 }, // Mil Mi-35 (export Mi-24)

  // Kamov helicopters (Russian)
  'KA27': { row: 20, col: 2 }, // Kamov Ka-27 - medium
  'KA32': { row: 20, col: 2 }, // Kamov Ka-32 - medium
  'KA52': { row: 18, col: 3 }, // Kamov Ka-52 Alligator - attack

  // Other military helicopters
  'UH1H': { row: 0, col: 7 },  // UH-1H Huey
  'UH1N': { row: 0, col: 7 },  // UH-1N Twin Huey
  'UH1Y': { row: 0, col: 7 },  // UH-1Y Venom
  'AH1': { row: 0, col: 7 },   // AH-1 Cobra - use UH1 sprite
  'AH1Z': { row: 0, col: 7 },  // AH-1Z Viper
  'CH53': { row: 21, col: 5 }, // CH-53 Sea Stallion - heavy
  'MH53': { row: 21, col: 5 }, // MH-53 Pave Low
  'A129': { row: 22, col: 4 }, // AW129 Mangusta - attack, use TIGR sprite
  'T129': { row: 22, col: 4 }, // TAI T129 ATAK - attack
  'EH10': { row: 20, col: 2 }, // EH101/AW101 Merlin - medium
  'AW01': { row: 20, col: 2 }, // AW101 Merlin
  'MERLN': { row: 20, col: 2 }, // EH101 Merlin

  // ── Business jets / GA twins that were listed in the size-category arrays
  // below but had NO sprite position, so they fell through to the default
  // cell and rendered as an invisible marker (label, no icon). Mapped onto
  // the closest already-verified silhouette: light jets -> C25B (Citation),
  // mid/large jets -> C750 (Citation X), twin turboprops -> D228.
  'C25A': { row: 13, col: 1 }, // Citation CJ2 - same family as C25B
  'LJ45': { row: 13, col: 1 }, // Learjet 45 - light jet
  'BE40': { row: 13, col: 1 }, // Beechjet 400 - light jet
  'E50P': { row: 13, col: 1 }, // Phenom 100 - light jet
  'E55P': { row: 13, col: 1 }, // Phenom 300 - light jet
  'CL30': { row: 13, col: 4 }, // Challenger 300
  'CL35': { row: 13, col: 4 }, // Challenger 350
  'CL60': { row: 13, col: 4 }, // Challenger 600
  'GLEX': { row: 13, col: 4 }, // Global Express
  'G280': { row: 13, col: 4 }, // Gulfstream G280
  'C56X': { row: 13, col: 4 }, // Citation Excel/XLS
  'C680': { row: 13, col: 4 }, // Citation Sovereign
  'C68A': { row: 13, col: 4 }, // Citation Latitude
  'C700': { row: 13, col: 4 }, // Citation Longitude
  'LJ60': { row: 13, col: 4 }, // Learjet 60
  'BE20': { row: 14, col: 2 }, // King Air 200 - twin turboprop
  'P31': { row: 14, col: 2 },  // Piper PA-31 Navajo - piston twin
  'PA34': { row: 14, col: 2 }, // Piper Seneca - piston twin
  'BE58': { row: 14, col: 2 }, // Beech Baron - piston twin
};

// ─── Icon size tiers ─────────────────────────────────────────────────────────
//
// Every silhouette in beluga_sprites.png is drawn to fill its 72px cell, so
// the sprite itself carries NO scale — a C172 and an A380 are the same pixel
// size until this multiplier is applied. Rendered size is therefore entirely
// decided here.
//
// Real sizes span ~7x (C172 11 m wingspan → A380 80 m). A linear scale would
// make GA invisible or heavies cover the map, so aircraft are GROUPED into a
// compressed ladder: each step is "a bit bigger" than the one below it.
// Helicopters use the same ladder (light / medium / heavy) but sit one step
// above their true size — the rotor+tail silhouettes are thin and need it to
// stay visible.
//
// Table icons scale from 12–24px bases, so the bottom of the ladder cannot
// go much below 0.65 or those icons drop under 8px.
export const SIZE_TIERS = Object.freeze({
  GA: 0.65,          // light singles/twins, gliders, trainers
  BUSINESS: 0.78,    // light/midsize business jets, turboprop twins, fighters, light helicopters
  REGIONAL: 0.9,     // regional jets/turboprops, large-cabin business jets, medium helicopters
  NARROWBODY: 1.0,   // A320/737 class, 757, tactical transports, heavy helicopters
  HEAVY: 1.3,        // widebodies, 707 family (4-engined, A340-like on the map)
  JUMBO: 1.45,       // A380, 747, An-124/225, C-5, Beluga/Dreamlifter
});

// Type → tier. Types are listed under exactly one tier; a type that appears
// in aircraftSpriteMap but in none of these lists is a bug (see the unit test).
// DB-only designators (admin-assigned, no bundled sprite) are included too so
// they size correctly instead of falling back to their sprite cell's tier.
const sizeTierGroups = [
  [SIZE_TIERS.GA, [
    // GA singles
    'C150', 'C152', 'C162', 'C172', 'C72R', 'C175', 'C177', 'C77R', 'C180', 'C182',
    'C82R', 'C82T', 'C185', 'C205', 'C206', 'T206', 'C207', 'C210', 'T210', 'P210',
    'CC19', 'P28A', 'PA46', 'SR20', 'SR22', 'S22T', 'M20P', 'M20T', 'WT9', 'SD4',
    'PIVI', 'PIVE', 'PIAT', 'PIAE', 'P46T', 'P28B', 'P28R', 'P28T', 'PA32', 'P32R', 'P32T',
    'BE33', 'BE35', 'BE36', 'DA40',
    'TWEN', 'P208', 'ECHO', 'SIRA', 'ASTO', 'BRAV', 'GOLF',
    'C208', 'PC6T', 'DO27', 'DO28', 'BN2P', 'E300', 'PC9', 'ST75',
    'TEX2', 'T6', 'PC21', 'TUCA',
    // GA / light piston twins
    'P31', 'PA34', 'BE58', 'F406', 'DA42', 'DA62', 'P06T', 'P212',
    // gliders, motor gliders, autogyros
    'ASK2', 'SF25', 'GYRO',
  ]],
  [SIZE_TIERS.BUSINESS, [
    // light / very light jets
    'C25A', 'C25B', 'C25C', 'C25M', 'C510', 'C525', 'C560', 'HJET', 'E50P',
    'E55P', 'LJ35', 'LJ45', 'LJ60', 'BE40', 'H25B', 'FA10', 'FA20',
    // midsize / super-midsize jets
    'C56X', 'C680', 'C68A', 'C700', 'C750', 'CL30', 'CL35', 'E545', 'E550',
    'G280', 'GALX', 'FA50',
    // turboprop twins / commuters
    'BE20', 'B350', 'PC12', 'P180', 'B190', 'D228', 'TBM7', 'TBM8', 'TBM9',
    // fighters, jet trainers, small military
    'EUFI', 'F15', 'F16', 'F18H', 'F18S', 'F22', 'F35', 'VF35', 'F5', 'A4',
    'A10', 'HAWK', 'HUNT', 'L159', 'M326', 'MIRA', 'MRF1', 'RFAL', 'SB39',
    'T38', 'U2',
    // light helicopters (one step above true size — see header)
    'R22', 'R44', 'R66', 'B06', 'B206', 'B407', 'B505', 'BH06', 'BH07',
    'MD52', 'MD60', 'NOTR', 'EC20', 'H120', 'EC30', 'H130', 'AS50', 'H125',
    'AS55', 'EC35', 'H135', 'A109', 'A119', 'AW09', 'AW19', 'MD90', 'EXPL',
    'B105', 'EC45', 'H145', 'BK17', 'A169', 'AW69', 'B222', 'B230', 'B427',
    'B429', 'B430', 'AS21',
  ]],
  [SIZE_TIERS.REGIONAL, [
    // regional jets
    'CRJ2', 'CRJ7', 'CRJ9', 'CRJX', 'E135', 'E145', 'E170', 'E175', 'E75L',
    'E75S', 'E275', 'E190', 'E195', 'E290', 'E295', 'RJ85', 'SU95', 'D442',
    // large-cabin business jets — CRJ/ERJ-sized (Global 7500 spans 32 m, a
    // Falcon 7X 26 m, a Challenger 600 IS the CRJ-200 fuselage), so they sit
    // a step above the Citations rather than with them
    'GLEX', 'GL5T', 'GL7T', 'GLF4', 'GLF5', 'GLF6', 'GA5C', 'GA6C', 'GA7C',
    'GA8C', 'F900', 'F2TH', 'FA6X', 'FA7X', 'FA8X', 'CL60', 'E35L',
    // regional turboprops
    'AT45', 'AT72', 'AT75', 'AT76', 'AT82', 'ATP', 'DH8C', 'DH8D', 'D328',
    'J328', 'SF34', 'F50', 'AN26', 'C295', 'C160', 'DC3', 'CL2T', 'Q4',
    // medium helicopters
    'UH1', 'UH1H', 'UH1N', 'UH1Y', 'B205', 'B212', 'B214', 'B412', 'AH1', 'AH1Z',
    'H60', 'UH60', 'S70', 'S70A', 'S70B', 'S70I', 'H60L', 'H60M', 'MH60',
    'SH60', 'HH60', 'H64', 'AH64', 'LYNX', 'MIL24', 'MI24', 'MI35', 'MI28',
    'NH90', 'TIGR', 'A129', 'T129', 'A139', 'A149', 'AW39', 'W3', 'S76',
    'S76A', 'S76B', 'S76C', 'S76D', 'H160', 'KA27', 'KA32', 'KA52', 'AS65',
    'EC55', 'H155', 'EC75', 'H175', 'AS32', 'EC25', 'H215', 'H225', 'MI8',
    'MI17',
  ]],
  [SIZE_TIERS.NARROWBODY, [
    // A320 / 737 / A220 families
    'A318', 'A319', 'A19N', 'A320', 'A20N', 'A321', 'A21N', 'BCS1', 'BCS3',
    'B732', 'B733', 'B734', 'B735', 'B736', 'B737', 'B738', 'B739', 'B37M',
    'B38M', 'B39M', 'B3XM',
    // other narrowbodies
    'B752', 'B753', 'B722', 'B712', 'DC87', 'IL62', 'T204',
    // narrowbody-sized military
    'E737', 'P1', 'P3', 'B29', 'C130', 'C30J', 'AN12', 'E390',
    // heavy helicopters
    'H47', 'CH47', 'MI26', 'CH53', 'MH53', 'S61', 'S64', 'S92', 'A189',
    'AW89', 'B525', 'EH10', 'AW01', 'MERLN',
  ]],
  [SIZE_TIERS.HEAVY, [
    'A306', 'A310', 'A3ST', 'A332', 'A333', 'A337', 'A338', 'A339',
    'A342', 'A343', 'A345', 'A346', 'A359', 'A35K',
    'B762', 'B763', 'B764', 'B772', 'B773', 'B77L', 'B77W', 'B788', 'B789',
    'B78X', 'DC10', 'MD11', 'IL76', 'A400', 'C17', 'KC2', 'B52', 'SGUP',
    // 707 family — four-engined, so shown at A340-like size rather than
    // narrowbody, where the four small engines are not legible
    'B701', 'B703', 'E3CF', 'E3TF', 'KE3', 'E8', 'K35E', 'R135', 'C135',
  ]],
  [SIZE_TIERS.JUMBO, [
    'A388', 'B742', 'B744', 'B748', 'B74S', 'B779', 'BLCF', 'A124', 'A225', 'C5M',
  ]],
];

const sizeTierByType = new Map();
sizeTierGroups.forEach(([tier, types]) => types.forEach(t => sizeTierByType.set(t, tier)));

// Tier of the canonical type drawn in each sprite cell. Used as the fallback
// for admin-assigned designators that have no explicit tier: the admin picked
// a lookalike silhouette, so its tier is the best available guess.
const sizeTierByCell = new Map();
Object.keys(aircraftSpriteMap).forEach(t => {
  const tier = sizeTierByType.get(t);
  const { row, col } = aircraftSpriteMap[t];
  const key = `${row},${col}`;
  if (tier !== undefined && !sizeTierByCell.has(key)) sizeTierByCell.set(key, tier);
});

/**
 * True when the designator has its own entry in the size tiers (as opposed
 * to sizing by its sprite cell). Every bundled type must satisfy this.
 * @param {string} aircraftType
 * @returns {boolean}
 */
export function hasExplicitSizeTier(aircraftType) {
  return !!aircraftType && sizeTierByType.has(aircraftType.toUpperCase());
}

/**
 * Icon size multiplier for an aircraft type. Unknown types (no sprite at all)
 * render as the "?" placeholder silhouette, sized on the business tier.
 * @param {string} aircraftType ICAO type designator
 * @returns {number}
 */
export function getAircraftSizeMultiplier(aircraftType) {
  if (!aircraftType) return SIZE_TIERS.BUSINESS;

  const type = aircraftType.toUpperCase();
  const explicit = sizeTierByType.get(type);
  if (explicit !== undefined) return explicit;

  if (!hasAircraftSprite(type)) return SIZE_TIERS.BUSINESS;

  const pos = getAircraftSpritePosition(type);
  const byCell = sizeTierByCell.get(`${pos.row},${pos.col}`);
  return byCell !== undefined ? byCell : SIZE_TIERS.REGIONAL;
}

// Runtime overrides loaded from the backend (admin-assigned mappings).
// Populated by setRuntimeAircraftSpriteOverrides() at app boot. DB entries
// take precedence over the bundled static map so admin assignments take
// effect without a FE redeploy.
let runtimeOverrides = {};

/**
 * Replace the runtime override layer with a fresh map fetched from the
 * backend. Call once at boot (and whenever the admin saves a change).
 * @param {Object<string,{row:number,col:number}>} overrides
 */
export function setRuntimeAircraftSpriteOverrides(overrides) {
  if (!overrides || typeof overrides !== 'object') {
    runtimeOverrides = {};
    _spriteCacheVersion++;
    return;
  }
  const next = {};
  Object.keys(overrides).forEach(k => {
    const v = overrides[k];
    if (v && Number.isFinite(v.row) && Number.isFinite(v.col)) {
      next[k.toUpperCase()] = { row: v.row, col: v.col };
    }
  });
  runtimeOverrides = next;
  _spriteCacheVersion++;  // invalidate getAircraftSpritePosition cache
}

// Memoized lookup: this is called per-row on every render of the
// aircraft tables (History, Predictions). The bare toUpperCase + double map
// lookup adds up to thousands of allocations per render at busy airports.
// Cache is invalidated when runtimeOverrides changes.
const _spriteCache = new Map();
let _spriteCacheVersion = 0;
// Fallback for any type with no mapping (unknown, new, or malformed type codes
// such as a truncated "321-"): row 0 col 0, the sprite sheet's "unknown"
// silhouette — a generic airframe with a "?" on the fuselage and no engines.
// (Row 0 col 1 is the piston-single "?" variant; row 0 col 2 the rear-engined
// jet "?" variant.) Every airliner type is mapped explicitly.
const _defaultSprite = Object.freeze({ row: 0, col: 0 });

/**
 * True when the designator has a silhouette of its own — bundled or
 * admin-assigned. A type that fails this renders as the generic default
 * cell, which is how a bogus family code like 'A330' (not an ICAO
 * designator; the real ones are A332/A333/A339…) shows up on the map.
 * Consider the runtime overrides too: a type mapped only in the DB is a
 * KNOWN type.
 * @param {string} aircraftType
 * @returns {boolean}
 */
export function hasAircraftSprite(aircraftType) {
  if (!aircraftType) return false;
  const type = aircraftType.toUpperCase();
  return !!(runtimeOverrides[type] || aircraftSpriteMap[type]);
}

// Get sprite position for an aircraft type
export function getAircraftSpritePosition(aircraftType) {
  if (!aircraftType) return _defaultSprite;

  // Cache key includes the override version so that setOverrides() invalidates.
  const cached = _spriteCache.get(aircraftType);
  if (cached && cached._v === _spriteCacheVersion) return cached.pos;

  const type = aircraftType.toUpperCase();
  const pos = runtimeOverrides[type] || aircraftSpriteMap[type] || _defaultSprite;
  _spriteCache.set(aircraftType, { pos, _v: _spriteCacheVersion });
  return pos;
}

// Get CSS class for aircraft sprite
export function getAircraftSpriteClass(aircraftType) {
  const pos = getAircraftSpritePosition(aircraftType);
  return `aircraft-sprite-${pos.row}-${pos.col}`;
}

export default aircraftSpriteMap;
